// App

// 3rd-party Libraries

import 'minireset.css';
import 'slick-carousel/slick/slick.css';

import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

window.jQuery = require('jquery');
require('sly-scrolling/dist/sly');

// Application Globals

import './globals/base/';
import './globals/fonts/icon-font/';
import './globals/fonts/montserrat/';
import './globals/fonts/open-sans/';
import './globals/images/';

// Application Widgets

import Application from './widgets/application/';
import SiteHeader from './widgets/site-header/';
import SiteFooter from './widgets/site-footer/';
import SiteNav from './widgets/site-nav/';
import HeroSlider from './widgets/hero-slider/';
import HeroSliderText from './widgets/hero-slider-text/';
import PageJoboffer from './widgets/page-joboffer/';
import FallbackJobofferBox from './widgets/fallback-joboffer-box/';
import './widgets/page-joboffer-list/';
import './widgets/page-static/';
import Form from './widgets/form/';
import './widgets/form-error-message/';
import './widgets/form-success-message/';
import './widgets/tag/';
import './widgets/block/';
import './widgets/block-image/';
import './widgets/block-page-links/';
import './widgets/block-text/';
import './widgets/block-contact-box/';
import './widgets/block-video/';
import Popup from './widgets/popup/';
import './widgets/widget/';
import './widgets/widget-ap/';
import './widgets/widget-benefits/';
import './widgets/widget-job-attributes/';
import OffersList from './widgets/widget-joboffer-list/';
import './widgets/widget-our-company/';
import './widgets/widget-text/';
import NewsletterSignup from './widgets/newslettersignup/';
import './widgets/widget-bigimage-with-text/';
import ExperienceReportTeaser from './widgets/experience-report-teaser/';
import WidgetTabs from './widgets/widget-tabs/';
import WidgetAccordion from './widgets/widget-accordion/';
import './widgets/widget-text-columns/';
import './widgets/widget-contact-box/';
import PageTeasers from './widgets/widget-page-teasers/';
import SocialWall from './widgets/social-wall/';
import SectionMenu from './widgets/section-menu/';
import MenuAbstract from './widgets/menu-abstract/';

// Application

class App extends Application {
  constructor() {
    super();
  }

  // Event Handlers: Ready State Change

  handleReadyStateInteractive() {
    super.handleReadyStateInteractive();

    let pageTypeJoboffer = document.querySelector('.page-joboffer');
    window.pageTypeJoboffer = !!pageTypeJoboffer;

    let siteHeader = document.querySelector('.site-header');
    if (siteHeader) { this.siteHeader = new SiteHeader(siteHeader); }

    let siteFooter = document.querySelector('.site-footer');
    if (siteFooter) { this.siteFooter = new SiteFooter(siteFooter); }

    let sectionMenu = document.querySelector('.section-menu');
    if (sectionMenu) { this.sectionMenu = new SectionMenu(sectionMenu); }

    let siteNav = document.querySelector('.site-nav');
    if (siteNav) { this.siteNav = new SiteNav(siteNav); }

    let heroSlider = document.querySelector('.hero-slider');
    if (heroSlider) { this.heroSlider = new HeroSlider(heroSlider); }

    let heroSliderText = document.querySelector('.hero-slider-text');
    if (heroSliderText) { this.heroSliderText = new HeroSliderText(heroSliderText); }

    let pageJoboffer = document.querySelector('#page-joboffer');
    if (pageJoboffer) { this.pageJoboffer = new PageJoboffer(pageJoboffer); }

    let fallbackJobofferBox = document.querySelector('.widget-fallback-joboffer-box');
    if (fallbackJobofferBox) { this.fallbackJobofferBox = new FallbackJobofferBox(fallbackJobofferBox); }

    this.popups = [];
    document.querySelectorAll('.popup').forEach((popup) => {
        this.popups.push(new Popup(popup));
    });

    this.forms = [];
    document.querySelectorAll('.app-form').forEach((form) => {
        this.forms.push(new Form(form));
    });

    document.querySelectorAll('a[data-href]').forEach((link) => {
      link.addEventListener('click', (event) => {
        event.stopImmediatePropagation();
        event.preventDefault();

        window.location = link.href + '#' + link.dataset.href;
      });
    });

    document.querySelectorAll('a[href^="#"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        event.stopImmediatePropagation();
        event.preventDefault();

        const url = new URL(event.target.href);
        app.scrollToHash(url.hash);
      });
    });

    if (this.pageJoboffer) {
      let reopen = this.reopenPopup();
      if (reopen) {
        this.pageJoboffer.trackFormSend();
      } else {
        this.pageJoboffer.trackPageOpen();
      }
    }

    if (this.fallbackJobofferBox) {
      let reopen = this.reopenPopup();
    }

    let offersList = document.querySelector('.offers-list-with-filters');
    if (offersList) { this.offersList = new OffersList(offersList); }

    let newsletterSignup = document.querySelector('.newsletter-signup');
    if (newsletterSignup) { this.newsletterSignup = new NewsletterSignup(newsletterSignup); }

    this.experienceReportTeasers = [];
    document.querySelectorAll('.experience-report-teaser .sliders-wrapper').forEach((erTeaser) => {
      this.experienceReportTeasers.push(new ExperienceReportTeaser(erTeaser));
    });

    this.tabsWidgets = [];
    document.querySelectorAll('.widget-tabs').forEach((tabsElement) => {
      this.tabsWidgets.push(new WidgetTabs(tabsElement));
    });

    this.accordions = [];
    document.querySelectorAll('.widget-accordion').forEach((accordionElement) => {
      this.accordions.push(new WidgetAccordion(accordionElement));
    });

    let pageTeasers = document.querySelector('.widget-page-teasers');
    if (pageTeasers) { this.pageTeasers = new PageTeasers(pageTeasers); }

    let socialWall = document.querySelector('.widget-feed-list');
    if (socialWall) { this.socialWall = new SocialWall(socialWall); }

    this.menuAbstracts = [];
    document.querySelectorAll('.frame-type-menu_abstract').forEach((element) => {
      this.menuAbstracts.push(new MenuAbstract(element));
    });
  }

  handleReadyStateComplete() {
    super.handleReadyStateComplete();

    if (this.sectionMenu) { this.sectionMenu.reload(); }

    let heroSlider = document.querySelector('.hero-slider');
    if (heroSlider) { this.heroSlider.update(); }

    const link = new URL(window.location);
    if (link.hash === '#cookie-center') {
      if (typeof cookiefirst_show_settings === 'function') {
        cookiefirst_show_settings();
      } else {
        let interval = setInterval(() => {
          console.log('#cookie-center interval');

          if (typeof cookiefirst_show_settings === 'function') {
            cookiefirst_show_settings();
            clearInterval(interval);
          }
        }, 1000);
      }
    }
  }

  // Event Handlers: Resize

  handleResize() {
    super.handleResize();

    if (this.sectionMenu) { this.sectionMenu.resize(); }
    if (this.siteNav) { this.siteNav.resize(); }
    if (this.pageJoboffer) { this.pageJoboffer.resize(); }
  }

  handleResizeFinished() {
    super.handleResizeFinished();
  }

  // Event Handlers: Scroll

  handleScroll(event) {
    super.handleScroll();

    if (this.siteHeader) { this.siteHeader.scroll(); }
    if (this.sectionMenu) { this.sectionMenu.scroll(); }
    if (this.siteNav) { this.siteNav.scroll(); }
    if (this.pageJoboffer) { this.pageJoboffer.scroll(); }
  }

  handleScrollFinished() {
    super.handleScrollFinished();
  }

  // Helpers

  reopenPopup() {
    let reopen = false;

    const url = new URL(window.location.href);
    if (!url.hash) { return reopen; }

    const form = document.querySelector(url.hash);
    if (!form) { return reopen; }

    this.popups.forEach((popup) => {
      if (popup.root.contains(form)) {
        popup.open();
        reopen = true;
      }
    });

    return reopen;
  }

  openDataHref() {
    document.querySelectorAll('[data-href]').forEach((item) => {
      item.style.cursor = 'pointer';
      item.addEventListener('click', (event) => {
        event.stopImmediatePropagation();
        event.preventDefault();

        let dataHref = item.dataset.href;
        let dataTarget = item.dataset.target;

        if (dataHref && dataTarget) {
          window.open(dataHref, dataTarget);
        } else if (dataHref) {
          window.location.href = dataHref;
        }
      });
    });
  }
}

window.app = new App();
